module.exports = __webpack_public_path__ + "img/1f9e5.c02fc47.svg";